export function merge(target, source) {
	for (const k in source) {
		if (target[k] === undefined) target[k] = source[k]; // eslint-disable-line no-param-reassign
		if (typeof target[k] === 'object' && typeof source[k] === 'object') merge(target[k], source[k]);
		else target[k] = source[k]; // eslint-disable-line no-param-reassign
	}
}
